import { readonly, ref } from 'vue'

const isOrganizationListingUpdated = ref(false)

export const useOrganizationListing = (): any => {
  const updateOrganizationListing = (isUpdated: boolean) => {
    isOrganizationListingUpdated.value = isUpdated
  }

  return {
    isOrganizationListingUpdated: readonly(isOrganizationListingUpdated),
    updateOrganizationListing,
  }
}
